<template>
  <el-row>
    <!-- 菜单 -->
    <el-row style="width:70%; margin:0 auto; ">
      <el-row>
        <el-menu
          default-active="/OfflinePay"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b">
          <el-menu-item index="/MyBill">新生缴费</el-menu-item>
          <el-menu-item index="/OfflinePay">线下审核</el-menu-item>
          <el-menu-item index="/Exit">退出</el-menu-item>
        </el-menu>
        <br>
        <br>
      </el-row>
    </el-row>
    <!-- 学生信息 -->
    <el-row class="content" v-if="curStudent.studentName">
      <el-row class="content-main">
        <el-form :model="curStudent" label-width="90px" style="background-color: #fff">
          <el-form-item label="姓名" class="form-item">
            <span class="label_value">{{ curStudent.studentName }}</span>
          </el-form-item>
          <el-form-item label="身份证号" class="form-item">
            <span class="label_value">{{ curStudent.uid }}</span>
          </el-form-item>
          <el-form-item label="专业" class="form-item">
            <span class="label_value">{{ curStudent.majorMatr }}</span>
          </el-form-item>
          <el-form-item label="学年" class="form-item">
            <span class="label_value">{{ curStudent.enrollmentYear }}</span>
          </el-form-item>
        </el-form>
      </el-row>
    </el-row>
    <!-- 申请记录列表 -->
    <el-row class="content">
      <el-row class="content-main">
        <div class="section-title">申请记录</div>
        <div v-if="applyList.length === 0" style="text-align: center; padding: 20px; color: #999;">
          暂无申请记录
        </div>
        <div v-for="item in applyList" :key="item.orderNo" class="apply-item">
          <el-row class="apply-row">
            <el-col :span="16">
              <span class="apply-label">申请单号：</span>
              <span class="apply-value">{{ item.orderNo }}</span>
            </el-col>
            <el-col :span="8" style="text-align: right;">
              <van-tag :type="getStatusTagType(item.dataStatus)">{{ formatStatus(item.dataStatus) }}</van-tag>
            </el-col>
          </el-row>
          <el-row class="apply-row">
            <el-col :span="24">
              <span class="apply-label">申请时间：</span>
              <span class="apply-value apply-time">{{ formatTime(item.dataTime) }}</span>
            </el-col>
          </el-row>
          <el-row class="apply-row" v-if="item.userName">
            <el-col :span="24">
              <span class="apply-label">申请人：</span>
              <span class="apply-value">{{ item.userName }}</span>
            </el-col>
          </el-row>
          <el-row class="apply-row" v-if="item.dataStatus === '02' && item.remark">
            <el-col :span="24">
              <span class="apply-label">拒绝原因：</span>
              <span class="apply-value reject-reason">{{ item.remark }}</span>
            </el-col>
          </el-row>
        </div>
      </el-row>
    </el-row>
  </el-row>
</template>
<script>
export default {
  name: 'OfflinePay',
  data: function () {
    return {
      curStudent: {},
      applyList: []
    }
  },
  mounted: function () {
    this.curStudent = this.global.curStudent
    this.loadApplyList()
  },
  methods: {
    handleSelect: function (index) {
      var self = this
      if (index === '/MyBill') {
        self.$router.push('/myBillXiFanNew')
      } else if (index === '/OfflinePay') {
        // 已经在当前页面,不需要跳转
      } else if (index === '/Exit') {
        self.$router.push('/')
      }
    },
    // 加载申请记录
    loadApplyList: function () {
      var self = this
      self.axios.post('/pay/queryAllFeeApply', {
        uid: self.curStudent.uid
      })
        .then(function (response) {
          if (response.data.result.success) {
            self.applyList = response.data.applyList || []
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 状态码转中文
    formatStatus: function (code) {
      var map = {
        '00': '已通过',
        '01': '待审核',
        '02': '已拒绝/失效'
      }
      return map[code] || code
    },
    // 状态标签类型
    getStatusTagType: function (dataStatus) {
      var map = {
        '00': 'success',
        '01': 'warning',
        '02': 'danger'
      }
      return map[dataStatus] || 'default'
    },
    // 格式化时间
    formatTime: function (time) {
      if (!time || time.length < 14) return time || ''
      return time.substring(0, 4) + '-' + time.substring(4, 6) + '-' + time.substring(6, 8) +
        ' ' + time.substring(8, 10) + ':' + time.substring(10, 12) + ':' + time.substring(12, 14)
    }
  }
}
</script>
<style scoped>
.content {
  width: 95%;
  margin: 0.5rem auto;
}
.content-main {
  background-color: #fff;
  border-radius: 5px;
  overflow: hidden;
  padding: 10px;
}
.form-item {
  margin-bottom: 5px;
}
.label_value {
  color: #333;
  font-size: 14px;
}
.section-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
}
.apply-item {
  padding: 10px;
  border-bottom: 1px solid #f0f0f0;
}
.apply-item:last-child {
  border-bottom: none;
}
.apply-row {
  margin-bottom: 6px;
  line-height: 24px;
}
.apply-label {
  color: #999;
  font-size: 12px;
}
.apply-value {
  color: #333;
  font-size: 13px;
}
.apply-time {
  color: #1989fa;
  font-weight: 500;
}
.reject-reason {
  color: #ee0a24;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// OfflinePay.vue?6c251414